<template>
  <div class="page-container">
    <span class="parent-path">公司管理 / </span><span class="current-path">新增公司</span>
    <span class="page-title">新增公司</span>
    <div class="card-content">
      <a-form @submit.prevent="handleSubmit" class="company-form">
        <!-- 公司資訊 -->
        <div class="section">
          <h2>公司資訊</h2>
          <div class="form-grid">
            <a-form-item :validateStatus="errors.name ? 'error' : ''" :help="errors.name">
              <a-label for="companyName">公司名稱</a-label>
              <a-input v-model:value="form.name" id="companyName" type="text" placeholder="請輸入公司名稱"/>
            </a-form-item>
            <a-form-item :validateStatus="errors.tax_id ? 'error' : ''" :help="errors.tax_id">
              <a-label for="taxId">統一編號</a-label>
              <a-input v-model:value="form.tax_id" id="taxId" type="text" placeholder="請填寫統一編號"/>
            </a-form-item>
            <a-form-item :validateStatus="errors.address ? 'error' : ''" :help="errors.address">
              <a-label for="address">地址</a-label>
              <a-input v-model:value="form.address" id="address" type="text" placeholder="請輸入地址"/>
            </a-form-item>
            <a-form-item :validateStatus="errors.representative ? 'error' : ''" :help="errors.representative">
              <a-label for="representative">公司代表人</a-label>
              <a-input v-model:value="form.representative" id="representative" type="text" placeholder="請填寫公司代表人"/>
            </a-form-item>
          </div>
        </div>

        <!-- 公司管理人 -->
        <div class="section">
          <h2>公司管理人</h2>
          <div class="form-grid">
            <a-form-item :validateStatus="errors.last_name ? 'error' : ''" :help="errors.last_name">
              <a-label for="lastName">姓氏</a-label>
              <a-input v-model:value="form.last_name" id="lastName" type="text" placeholder="請輸入管理人姓氏"/>
            </a-form-item>
            <a-form-item :validateStatus="errors.first_name ? 'error' : ''" :help="errors.first_name">
              <a-label for="firstName">名字</a-label>
              <a-input v-model:value="form.first_name" id="firstName" type="text" placeholder="請輸入管理人名字"/>
            </a-form-item>
            <a-form-item :validateStatus="errors.email ? 'error' : ''" :help="errors.email">
              <a-label for="email">電子信箱</a-label>
              <a-input v-model:value="form.email" id="email" type="email" placeholder="請輸入管理人電子信箱"/>
            </a-form-item>
            <a-form-item :validateStatus="errors.password ? 'error' : ''" :help="errors.password">
              <a-label for="password">密碼</a-label>
              <a-input
                  v-model:value="form.password"
                  id="password"
                  type="password"
                  placeholder="（包含英文文字及數字，長度為6個字元以上）"
              />
            </a-form-item>
          </div>
        </div>

        <div class="form-actions">
          <a-button type="button" class="btn-cancel" @click="handleCancel">取消</a-button>
          <a-button html-type="submit" class="btn-submit">新增</a-button>
        </div>
      </a-form>
    </div>
  </div>
</template>

<script>
import {message} from "ant-design-vue";

export default {
  data() {
    return {
      form: {
        name: "",
        tax_id: "",
        address: "",
        representative: "",
        last_name: "",
        first_name: "",
        email: "",
        password: "",
      },
      errors: {
        name: "",
        tax_id: "",
        address: "",
        representative: "",
        last_name: "",
        first_name: "",
        email: "",
        password: "",
      }
    };
  },
  methods: {
    handleSubmit() {
      console.log("表單提交", this.form);

      for (let key in this.errors) {
        this.errors[key] = ""
      }

      const token = localStorage.getItem('token');
      this.$axios.post('/api/organizations', this.form, {
        headers: {
          Authorization: `Bearer ${token}`
        }
      }).then(response => {
        console.log(response)
        message.success("已完成公司新增，並發送登入密碼給管理人")
        this.$router.go(-1)
      }).catch(error => {
        console.log(error);
        if (error.status === 401) {
          this.$router.push('/login');
        } else {
          console.log(error.response.data);
          let errors = error.response.data
          for (let key in errors) {
            this.errors[key] = errors[key]['message']
          }
        }
      });
    },
    handleCancel() {
      console.log("取消操作");
      this.$router.go(-1)
    },
  },
};
</script>

<style scoped>
.card-content {
  background-color: white;
  border-radius: 8px;
  width: 1024px;
  padding: 20px;
  margin-top: 28px;
}

h1 {
  font-size: 1.5em;
  margin-bottom: 1em;
}

.section {
  margin-bottom: 2em;
}

.section h2 {
  font-size: 1.2em;
  margin-bottom: 1em;
}

.form-grid {
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 1em;
}

/*.form-group {*/
/*  display: flex;*/
/*  flex-direction: column;*/
/*}*/

label {
  font-size: 0.9em;
  margin-bottom: 0.5em;
  color: #333;
}

input {
  padding: 0.7em;
  font-size: 1em;
  border: 1px solid #ccc;
  border-radius: 4px;
}

input:focus {
  outline: none;
  border-color: #007bff;
  box-shadow: 0 0 5px rgba(0, 123, 255, 0.5);
}

.form-actions {
  display: flex;
  justify-content: flex-end;
  gap: 1em;
}

.btn-cancel {
  background-color: #f8f9fa;
  color: #333;
}

.btn-submit {
  background-color: #007bff;
  color: white;
}

.btn-submit:hover {
  background-color: #0056b3;
}
</style>
